import * as React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import {
  CustomFontsView,
  useFontUpload,
} from "@v2/features/settings/shop/FontManager";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { ArrowLeft } from "lucide-react";

interface DesignLibraryCustomFontsProps {
  onBack?: () => void;
  onFontDeleted?: () => void;
}

export const DesignLibraryCustomFonts: React.FC<
  DesignLibraryCustomFontsProps
> = ({ onBack, onFontDeleted }) => {
  const projectId = useCurrentProjectId();
  const fontUploadHook = useFontUpload(projectId);
  const { triggerUpload, fileInputElement, processFiles, isUploading } =
    fontUploadHook;

  return (
    <div className="flex flex-col items-start flex-[1_0_0] self-stretch min-h-0 rounded-xl border-0.5 border-border bg-white shadow-sm">
      <div className="flex justify-between items-center self-stretch p-6 border-b-0.5 border-border">
        <div className="flex items-center gap-3">
          <Button
            icon
            variant="tertiary"
            size="sm"
            onClick={() => {
              onBack?.();
            }}
          >
            <ArrowLeft />
          </Button>
          <div className="text-base font-semibold">Custom Fonts</div>
        </div>
        <Button variant="secondary" size="sm" onClick={triggerUpload}>
          Upload Fonts
        </Button>
        {fileInputElement}
      </div>
      <div className="flex flex-1 flex-col self-stretch overflow-y-auto no-scrollbar p-6">
        <CustomFontsView
          fontUploadHook={{ processFiles, isUploading }}
          onFontDeleted={onFontDeleted}
        />
      </div>
    </div>
  );
};
